import { handleRest } from '../../h2Api'
import { LIST_SCHEDULES } from '../../actions/planning/courseplanner'

const initialState = {
  plans: []
}
const data = (state = initialState, action) => {
  switch (action.type) {
    case LIST_SCHEDULES:
      const rst = handleRest(action)

      return {
        ...state,
        plans: rst.result
      }
    default:
      return state
  }
}

export default data
